module.exports = "/assets/dist/images/bodystyles_trucks_sm.png?605a059c5a1cbb70b1a277b94290489f";